/***
 * @Authors:
 *      Ashwin Rai (ashwinrai.com)
 *      Nikhil Chougule
 ***/

/*** Imports ***/

/* Library imports */
import React, {Component} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";

/* Component imports */
import ContentLg from "../../../../ContentLg";
import ConstantsLg from "../../../../ConstantsLg";
import * as UtilityLg from "../../../../UtilityLg";
import TextboxLg from "../../../core/TextboxLg/TextboxLg";
import TextboxOutline from "../../../core/TextBoxOutline/TextBoxOutline";

/* Style imports */
import "./styles.css";
import Gutter from "../../../core/Gutter/Gutter";
import LoginFooter from "../../../core/LoginFooter/LoginFooter";
/*** End Imports ***/

class LoginScreen extends Component {
    constructor(props){
        super(props);

        this.state = {
            password: '',
            showPswd: false
        };

        UtilityLg.bindThisToAll(this, "onTxtBxPswdChange", "validate", "showTxtBxPswdAsInvalid",
            "onForgotPassword", "onTxtBxPswdEnter", "onTxtBxEmailEditClick", "onShowPswdClick"
        );
    }

    componentDidMount () {
    }

    onTxtBxPswdChange (value, respObj) {
        this.setState({
            password: value
        });
        this.props.onTxtBxPswdChange(value, respObj);
    }

    onTxtBxPswdEnter (index) {
        this.props.onTxtBxPswdEnter();
    }

    /* @public method */
    validate () {
        this.txtBxPswdRef.validateManually();
    }

    txtBxPswdFocusOut () {
        this.txtBxPswdRef.focusOut();
    }

    /* @public method */
    showTxtBxPswdAsInvalid () {
        this.txtBxPswdRef.showAsInvalid();
    }

    onTxtBxEmailEditClick () {
        this.props.onEmailEditClick();
    }

    onForgotPassword () {
        this.props.onForgotPassword();
    }

    onShowPswdClick (event) {
        const {showPswd} = this.state;
        this.setState({
            showPswd: !showPswd
        });
    }

    onClickChangeUserLoginModal = () => {
      this.props.onClickChangeUserLoginModal();
    };

    render () {
        const {
                password,
                showPswd
            } = this.state,
            {
                email,
                pswdValidationMsg
            } = this.props,
            btnShowClasses = classNames("btn-show-pswd",
                {"showing": showPswd}
            )
        ;

        return (
            <div className="recruiter-login-screen">

                <div className="rec-lg-content" style={{width: '100%'}}>
                    <div className="rec-lg-tbemail-wrpr" style= {{padding: '0 20px', position: 'relative'}}>
                    <TextboxOutline 
                            ref = { e => this.TxtBxEmailRef = e }
                            textBoxValue = {email}
                            pattern = {ConstantsLg.REGEX.EMAIL}
                            placeholder = {ContentLg.REC_EMAIL_PH}
                            // isRequired = {true}
                            onEnterClick = {this.onTxtBxEmailEnter}
                            maxLength = {50}
                            onChange = {this.onTxtBxEmailChange}
                            isDisabled = {true}
                        />
                        <img
                            className="btn-edit"
                            style = {{
                                top: '38px',
                                right: '30px'
                            }}
                            onClick={this.onTxtBxEmailEditClick}
                            src = {ConstantsLg.ICONS.EDIT_ICON_BLUE}
                        />
                            
                    </div>

                    {/* <Gutter height={20}/> */}

                    <div className="rec-lg-tbpswd-wrpr" style= {{padding: '0 20px', position: 'relative'}}>
                    <TextboxOutline
                            ref = {e=>this.txtBxPswdRef=e}
                            textBoxType = {showPswd ? "text" : "password"}
                            textBoxLabel = {"Password"}
                            textBoxValue = {password}
                            pattern = {ConstantsLg.REGEX.PSWD_ANY}
                            placeholder = {ContentLg.REC_PSWD_PH}
                            // isRequired = {true}
                            onEnterClick = {this.onTxtBxPswdEnter}
                            maxLength = {127}
                            onChange = {this.onTxtBxPswdChange}
                            isAutoFocus
                        />
                        <img
                            className = {btnShowClasses}
                            style = {{
                                top: '38px',
                                right: '30px'
                            }}
                            onClick = {this.onShowPswdClick}
                            src = {ConstantsLg.ICONS.SHOW_PASSWORD_BLUE}
                        />
                        

                        {
                            this.props.pswdValidationMsg ?
                                <div 
                                    style = {{
                                        font: 'normal 12px/14px GillSans Italic Regular',
                                        color: '#D0021B',
                                        position: 'absolute'
                                    }}
                                >
                                    {pswdValidationMsg}
                                </div>
                                :
                                null
                        }

                    </div>
                </div>

                <Gutter height={10}/>

                <div
                    className = "rls-forgot-password"
                    style = {{
                        width: '100%',
                        textAlign: 'center'
                    }}
                    onClick = {this.onForgotPassword}
                >
                    {ContentLg.BTN.FORGOT_PSWD}
                </div>

                <Gutter height ={14}/>

                <div className="rls-login-btn">
                    <div className="rls-login-btn-content" onClick={this.props.onClickLoginProfessional}>LOGIN</div>
                </div>
            </div>
        );
    }
}

LoginScreen.PropTypes = {

};

export default LoginScreen;


// WEBPACK FOOTER //
// ./src/components/ProfessionalLoginEmailMobile/components/LoginScreen/LoginScreen.js